/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyAlgorithmRequest {
    getFixupPrototypeFunction() { return CostAnomalyAlgorithmRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyAlgorithmRequest>): CostAnomalyAlgorithmRequest {
        let obj = Object.assign(new CostAnomalyAlgorithmRequest(), model);
        CostAnomalyAlgorithmRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyAlgorithmRequest>): CostAnomalyAlgorithmRequest {
        if (!model) return null;
        return CostAnomalyAlgorithmRequest.newInstance(<CostAnomalyAlgorithmRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyAlgorithmRequest) {
        if (!obj) return;

        models.CostAnomalyAlgorithmRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyAlgorithmRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyAlgorithmRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.data) {
            for (let val of this.data) {
                models.CostAnomalyDataPoint.fixupPrototype(val);
            }
        }
    }

    /**
     * List of timestamp and value pairs
     */
    data: Array<models.CostAnomalyDataPoint>;

}
